<template>
  <h2 class="pb-2 border-bottom">Servicios Generales de Atención Primaria</h2>
  <h3>Atención Primaria / Pediatría</h3>
  <ul>
    <li>Chequeos de rutina y cuidados preventivos — visitas regulares para adelantarse a posibles problemas de salud.</li>
    <li>Exámenes físicos anuales — evaluaciones completas para seguir su salud general.</li>
    <li>Consultas de bienestar — planes personalizados para apoyar un estilo de vida más saludable.</li>
    <li>Vacunas e inmunizaciones — protección para niños y adultos en todas las etapas de la vida.</li>
    <li>Exámenes escolares — chequeos obligatorios para mantener a los niños seguros y listos para la escuela.</li>
  </ul>

  <h3>Manejo de Condiciones Crónicas</h3>
  <ul>
    <li>Control de la diabetes — monitoreo continuo y tratamiento para mantener el azúcar en sangre bajo control.</li>
    <li>Control de la hipertensión — atención personalizada para manejar la presión arterial de manera eficaz.</li>
    <li>Trastornos de la tiroides — diagnóstico y tratamiento del hipotiroidismo, hipertiroidismo y condiciones relacionadas.</li>
    <li>Colesterol alto — planes para reducir el riesgo cardiovascular y mejorar el bienestar.</li>
    <li>Obesidad & control de peso — programas seguros y supervisados para alcanzar y mantener un peso saludable.</li>
  </ul>

  <h3>Atención Médica General</h3>
  <ul>
    <li>Exámenes de detección (presión arterial, colesterol, diabetes, etc.) — la detección temprana salva vidas.</li>
    <li>Atención aguda & consultas por enfermedad — alivio rápido para resfriados, gripes, infecciones y más.</li>
    <li>Tratamiento de lesiones menores & heridas — cuidado rápido y seguro para accidentes cotidianos.</li>
    <li>Atención de alergias & asma — diagnóstico y manejo para un alivio duradero.</li>
    <li>Dolores de cabeza & migrañas — evaluación y tratamiento para mejorar la calidad de vida.</li>
  </ul>

  <h3>Salud de la Mujer</h3>
  <ul>
    <li>Exámenes ginecológicos — atención preventiva y de rutina para todas las etapas de la vida.</li>
    <li>Asesoría en anticoncepción — decisiones seguras e informadas, adaptadas a sus necesidades.</li>
    <li>Manejo de la menopausia — alivio de síntomas y mejora del bienestar.</li>
    <li>Tratamiento para SOP & tiroides — planes integrales para el equilibrio hormonal.</li>
  </ul>

  <h3>Salud del Hombre</h3>
  <ul>
    <li>Programas de salud masculina — atención preventiva y especializada para pacientes hombres.</li>
    <li>Exámenes de próstata — detección temprana para mayor tranquilidad.</li>
    <li>Tratamiento de la disfunción eréctil — soluciones médicas seguras y discretas.</li>
    <li>Terapia de reemplazo de testosterona (TRT) — tratamiento supervisado para restaurar la vitalidad.</li>
  </ul>

  <h3>Terapias Hormonales & Especializadas</h3>
  <ul>
    <li>Terapia de reemplazo hormonal (HRT) — programas personalizados para energía, equilibrio y bienestar.</li>
    <li>Programas médicos de pérdida de peso — enfoques seguros y estructurados bajo supervisión profesional.</li>
    <li>Medicamentos para bajar de peso — recetados cuando es apropiado, para apoyar el control del peso.</li>
    <li>Salud metabólica & control del peso — estrategias para mejorar el metabolismo y lograr resultados duraderos.</li>
  </ul>

  <h3>Salud Mental & Conductual</h3>
  <ul>
    <li>Atención en salud mental y conductual — apoyo holístico para el bienestar emocional.</li>
    <li>Manejo de ansiedad & depresión — tratamientos basados en evidencia para estabilidad y alivio.</li>
    <li>Evaluación & tratamiento del TDAH — diagnóstico preciso y planes de apoyo personalizados.</li>
    <li>Tratamiento de trastornos del sueño — soluciones para mejorar el descanso y el rendimiento diario.</li>
  </ul>

  <h3>Procedimientos Menores</h3>
  <ul>
    <li>Reparación del lóbulo de la oreja — restauración de la forma después de daño o estiramiento.</li>
    <li>Extirpación de quistes — procedimiento quirúrgico simple y seguro realizado en el consultorio.</li>
  </ul>

  <h3>Servicios Adicionales que Ofrecemos</h3>
  <ul>
    <li>Consultas por telemedicina — atención virtual segura desde cualquier lugar.</li>
    <li>Terapias intravenosas (IV) & infusiones de vitaminas — energía, inmunidad e hidratación.</li>
    <li>Dermatología & cuidado de la piel (acné, erupciones, eliminación de lunares) — piel saludable con orientación médica.</li>
    <li>Salud sexual (pruebas de ITS, terapia hormonal) — atención confidencial y profesional.</li>
    <li>Programas para dejar de fumar — apoyo personalizado para abandonar el hábito de manera definitiva.</li>
  </ul>
  <p>“Desde niños hasta adultos, nuestro equipo bilingüe está listo para brindar atención accesible y personalizada en cada etapa de la vida. Programe su cita hoy mismo.”</p>
</template>

<script>
export default {
  name: 'ContentEs'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
